// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class AddressResource extends Resource {
    basePath: string = 'addresses/addresses/';

    objectPath: string = 'addresses/addresses/{ident}/';

    pending(query: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}pending/`,
            'GET', query,
        ).then((response) => response.data);
    }

    archived(query: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}archived/`,
            'GET', query,
        ).then((response) => response.data);
    }

    horizontal(query: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}horizontal/`,
            'GET', query,
        ).then((response) => response.data);
    }

    vertical(query: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}vertical/`,
            'GET', query,
        ).then((response) => response.data);
    }

    coverage(mapUuid: string, query: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}${mapUuid}/coverage/`,
            'GET', query,
        ).then((response) => response.data);
    }

    attributes(id: string, query: Object): Promise<Object> {
        return this.client._request(
            `${this._getObjectPath(id)}attributes/`,
            'GET', query,
        ).then((response) => response.data);
    }

    attributesPartialUpdate(id: string, data: Object): Promise<Object> {
        return this.client._request(
            `${this._getObjectPath(id)}attributes/`,
            'PATCH', data,
        ).then((response) => response.data);
    }

    listStreetNumbers(query: {
        town_id: string,
        q_name: string,
        str_name: string,
        [string]: any,
    }): Promise<Object> {
        return this.client._request(
            `${this.basePath}street-numbers/`,
            'GET', query,
        ).then((response) => response.data);
    }

    listBlocks(query: {
        town_id: string,
        q_name: string,
        [string]: any,
    }): Promise<Object> {
        return this.client._request(
            `${this.basePath}blocks/`,
            'GET', query,
        ).then((response) => response.data);
    }

    listEntrances(query: {
        town_id: string,
        q_name: string,
        [string]: any,
    }): Promise<Object> {
        return this.client._request(
            `${this.basePath}entrances/`,
            'GET', query,
        ).then((response) => response.data);
    }

    listFloors(query: {
        town_id: string,
        q_name: string,
        str_name: string,
        str_n: string,
        str_subn: string,
        block_n: string,
        entr_n: string,
        [string]: any,
    }): Promise<Object> {
        return this.client._request(
            `${this.basePath}floors/`,
            'GET', query,
        ).then((response) => response.data);
    }

    listAppartments(query: {
        town_id: string,
        q_name: string,
        str_name: string,
        str_n: string,
        str_subn: string,
        block_n: string,
        entr_n: string,
        floor_n: string,
        [string]: any,
    }): Promise<Object> {
        return this.client._request(
            `${this.basePath}appartments/`,
            'GET', query,
        ).then((response) => response.data);
    }

    getOrCreate(data: Object): Promise<Object> {
        return this.client._request(
            `${this.basePath}get_or_create_address/`,
            'POST', data,
        ).then((response) => response.data);
    }

    parse(address: string): Promise<Object> {
        return this.client._request(
            `${this.basePath}parse/`,
            'GET', { address },
        ).then((response) => response.data);
    }
}
